// @ngInject
export const InjectorDecorator: Function = ($injector: ng.auto.IInjectorService): void => {
  let invoke = <any>$injector.invoke;
  // Override injector's get with our own
  (<any>$injector).invoke = function (unused1: any, unused2: any, locals: any) {
    if (locals && locals.$scope && locals.$scope.$parent && locals.$scope.$parent.isActionHost) {
      locals.actionContract = {
        actionContext: locals.$scope.$parent.actionContext,
        actionDeferral: locals.$scope.$parent.actionDeferral
      };
    }
    // tslint:disable-next-line:no-invalid-this
    return invoke.apply(this, arguments);
  };
};
